import { render, staticRenderFns } from "./CategoryStateChip.vue?vue&type=template&id=407dae5f&scoped=true"
import script from "./CategoryStateChip.vue?vue&type=script&lang=ts"
export * from "./CategoryStateChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407dae5f",
  null
  
)

export default component.exports